// extracted by mini-css-extract-plugin
export default {"logo":"StorePage_logo__WGj4B","title":"StorePage_title__8DWjH","locationIcon":"StorePage_locationIcon__e+-cO","storeDetails":"StorePage_storeDetails__zJRQC"};